import { render, staticRenderFns } from "./setChoosePicByVoiceSimulation.vue?vue&type=template&id=41b37036&scoped=true"
import script from "./setChoosePicByVoiceSimulation.vue?vue&type=script&lang=js"
export * from "./setChoosePicByVoiceSimulation.vue?vue&type=script&lang=js"
import style0 from "./setChoosePicByVoiceSimulation.vue?vue&type=style&index=0&id=41b37036&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b37036",
  null
  
)

export default component.exports